import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import SearchBarB from 'components/SearchBar/SearchBarB';
import FontIcon from 'components/FontIcon';
import SearchButtonBase from '../SearchButtonBase';
import classes from './SearchButtonB.module.scss';

const SearchButtonB = (props) => {
  const [showSearch, setShowSearch] = React.useState(false);
  const searchBar = useRef(null);
  const searchButton = useRef(null);
  const searchBarContainer = useRef(null);

  useEffect(() => {
    if (showSearch) {
      searchBar.current.focus();
    }

    function handleClickOutside(event) {
      if ((searchBarContainer.current && !searchBarContainer.current.contains(event.target))
      && (searchButton.current && !searchButton.current.contains(event.target))) {
        setShowSearch(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const onClick = (e) => {
    e.preventDefault();
    setShowSearch(!showSearch);
  };

  const renderSearchBox = (inputText) => {
    const classObj = {
      [classes.invisibleBox]: !showSearch,
      [classes.visibleBox]: showSearch,
    };

    return (
      <div ref={searchBarContainer} className={classNames(classes.searchBar, classObj)}>
        <SearchBarB {...props} inputText={inputText} searchBarRef={searchBar} />
        <button
          className={classes.closeButton}
          onClick={() => setShowSearch(false)}
          aria-label='Close'
          type='button'
        >
          <FontIcon icon='far fa-times' />
        </button>
      </div>
    );
  };

  return (
    <SearchButtonBase
      {...props}
      ref={searchButton}
      searchButtonIcon='far fa-search'
      classes={classes}
      renderSearchBox={renderSearchBox}
      onClick={onClick}
    />
  );
};

export default SearchButtonB;
